<template>
  <div id="digital-flop">
    <dv-border-box-10 class="catdsBox">
      <div class="boxBorder">
        <div
          class="digital-flop-item"
          v-for="item in dataSummary"
          :key="item.id"
        >
          <div class="titleHeader">
            <i class="iconfont" :class="`${item.iconfont}`"></i>
            <div class="digital-flop-title">{{ item.title }}</div>
          </div>
          <div class="digital-flop">
            <dv-digital-flop
              :config="item.number"
              :style="{width: '120px', height: '50px'}"
            />
            <div class="unit">{{ item.unit }}</div>
          </div>
        </div>
        <dv-decoration-10 />
        <dv-decoration-10 class="decorationBox" />
      </div>
    </dv-border-box-10>
  </div>
</template>

<script>
export default {
  name: 'dataSummary',
  props: {
    summaryData: {
      type: Object,
      default: function () {
        return {
          employeeCount: 0,
          departmentCount: 0,
          processCount: 0,
          productCount: 0,
          taskCount: 0,
          completedCount: 0,
          smartDeviceCount: 0,
          rawMaterialCount: 0,
          videoCount: 0
        }
      },
      require: true
    }
  },
  data() {
    return {}
  },
  computed: {
    dataSummary: function () {
      return [
        {
          id: '1',
          title: '员工总数',
          iconfont: 'icon-yuangong',
          number: {
            number: [this.summaryData.employeeCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '人'
        },
        {
          id: '2',
          title: '车间数量',
          iconfont: 'icon-chejianjihua',
          number: {
            number: [this.summaryData.departmentCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '个'
        },
        {
          id: '3',
          title: '生产工序',
          iconfont: 'icon-gongxu',
          number: {
            number: [this.summaryData.processCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '道'
        },
        {
          id: '4',
          title: '产品数量',
          iconfont: 'icon-cangkukucun',
          number: {
            number: [this.summaryData.productCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '个'
        },
        {
          id: '5',
          title: '总任务量',
          iconfont: 'icon-renwu',
          number: {
            number: [this.summaryData.taskCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '件'
        },
        {
          id: '6',
          title: '完成数量',
          iconfont: 'icon-wancheng',
          number: {
            number: [this.summaryData.completedCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '件'
        },
        {
          id: '7',
          title: '智能设备',
          iconfont: 'icon-shebei',
          number: {
            number: [this.summaryData.smartDeviceCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '台'
        },
        {
          id: '8',
          title: '原料品类',
          iconfont: 'icon-yuanliaoxinxi',
          number: {
            number: [this.summaryData.rawMaterialCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '类'
        },
        {
          id: '9',
          title: '监控视频',
          iconfont: 'icon-jiankongshexiangtou',
          number: {
            number: [188],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '个'
        }
      ]
    }
  },
  mounted() {
    const { createData } = this
    createData()
    setInterval(this.createData, 30000)
  },
  methods: {
    createData() {
      const { randomExtend } = this
    },
    randomExtend(minNum, maxNum) {
      if (arguments.length === 1) {
        return parseInt(Math.random() * minNum + 1, 10)
      } else {
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
      }
    }
  }
}
</script>

<style lang="less">
#digital-flop {
  position: relative;
  height: 15%;
  flex-shrink: 0;
  background-color: rgba(6, 30, 93, 0.5);
  .catdsBox {
    box-sizing: border-box;

    .boxBorder {
      height: 100%;
      box-sizing: border-box;
      padding: 10px 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .decorationBox {
        transform: rotate(180deg);
      }
    }
  }

  .dv-decoration-10 {
    position: absolute;
    width: 95%;
    left: 2.5%;
    height: 5px;
    bottom: 0px;
  }

  .digital-flop-item {
    width: 11%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 3px solid rgb(6, 30, 93);
    border-right: 3px solid rgb(6, 30, 93);

    .titleHeader {
      display: flex;
      flex-direction: row;

      .iconfont {
        margin-right: 5px;
        font-size: 27px;
      }
    }
  }

  .digital-flop-title {
    font-size: 21px;
    font-weight: 800;
    margin-bottom: 20px;
  }

  .digital-flop {
    display: flex;
  }

  .unit {
    font-size: 20px;
    margin-left: 10px;
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    padding-bottom: 13px;
  }
}
</style>
